import { render, staticRenderFns } from "./ModalVirtualCam.vue?vue&type=template&id=71deacc4&scoped=true&"
import script from "./ModalVirtualCam.vue?vue&type=script&lang=js&"
export * from "./ModalVirtualCam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71deacc4",
  null
  
)

export default component.exports